/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Link, NavLink, useLocation} from 'react-router-dom'
import {useThemeMode} from '../../_metronic/partials/layout/theme-mode/ThemeModeProvider'

import { Logo } from '../components/Logo'
import {UserMenuDropdown} from '../components/UserMenuDropdown'
import UserSymbol from '../components/UserPicture'

import {useAuth} from '../context/auth'

import { useLang } from '../../_metronic/i18n/Metronici18n';

import { UserType } from '../models'

const AdminLayout = () => {
  
  const {mode, updateMode} = useThemeMode()

  const location = useLocation()

  useEffect(() => {
    updateMode(mode)
  }, [mode])

  const {currentUser} = useAuth()

  const selectedLang = useLang()

  return (
    <div className="d-flex flex-column flex-root p-5">
      <div className="d-flex flex-row">
        <Link to="/c" className="p-2 mt-1">
          <Logo/>
        </Link>
        <div className="d-flex flex-row flex-row-fluid justify-content-between">
          <div className="d-flex flex-row flex-row-fluid justify-content-between">
            <div className="menu menu-rounded menu-gray-600 menu-active-bg-light-primary menu-hover-bg-light-primary menu-here-bg-light-primary menu-show-bg-light-primary fw-semibold ms-5" data-kt-menu="true">
              { currentUser?.type === UserType.ADMIN && (
                <div className="menu-item me-2">
                  <NavLink to="settings" className="menu-link">
                    <span className="menu-title">Settings</span>
                  </NavLink>
                </div>
              )}
              { currentUser && currentUser.type && [UserType.ADMIN, UserType.MANAGER].includes(currentUser.type) && (
              <div className="menu-item me-2">
                <NavLink to="users" className="menu-link">
                  <span className="menu-title">Users</span>
                </NavLink>
              </div>
              )}
            </div>

            <div className="menu menu-rounded menu-gray-600 menu-active-bg-light-primary menu-hover-bg-light-primary menu-here-bg-light-primary menu-show-bg-light-primary fw-semibold ms-5" data-kt-menu="true">
              <div className="menu-item me-2">
                <span className="menu-link disabled" style={{'cursor':'auto'}}>
                  <span className="menu-title">Orchestrator</span>
                </span>
              </div>

              { currentUser && currentUser.type && [UserType.ADMIN, UserType.MANAGER].includes(currentUser.type) && (
              <div className="menu-item me-2" data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement={`bottom`}>
                <NavLink to="api-accesses"  className={`menu-link ${location.pathname.includes('api-access') && 'active'}`}>
                  <span className="menu-title">API</span>
                </NavLink>
                <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg px-lg-2 py-lg-4 w-lg-200px">
                  <div className="menu-item px-2">
                    <NavLink to="api-accesses" className="menu-link">
                      <span className="menu-title">Accesses</span>
                    </NavLink>
                  </div>
                  <div className="menu-item px-2">
                    <NavLink to="api-access-requests" className="menu-link">
                      <span className="menu-title">Requests</span>
                    </NavLink>
                  </div>
                </div>
              </div>
              )}
              { currentUser?.type === UserType.ADMIN && (
              <div className="menu-item me-2" data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-placement={`bottom`}>
                <NavLink to="content-moderation/interventions" className={`menu-link ${location.pathname.includes('content-moderation') && 'active'}`}>
                  <span className="menu-title">Content Moderation</span>
                </NavLink>
                <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg px-lg-2 py-lg-4 w-lg-150px">
                  <div className="menu-item px-2">
                    <NavLink to="content-moderation/interventions" className="menu-link">
                      <span className="menu-title">Intervention</span>
                    </NavLink>
                  </div>
                  <div className="menu-item px-2">
                    <NavLink to="content-moderation/blocklists/text" className="menu-link">
                      <span className="menu-title">Blocklist (Text Generation)</span>
                    </NavLink>
                  </div>
                  <div className="menu-item px-2">
                    <NavLink to="content-moderation/blocklists/image" className="menu-link">
                      <span className="menu-title">Blocklist (Image Generation)</span>
                    </NavLink>
                  </div>
                  <div className="menu-item px-2">
                    <NavLink to="content-moderation/islamic" className="menu-link">
                      <span className="menu-title">Islamic</span>
                    </NavLink>
                  </div>
                </div>
              </div>
              )}
            </div>
          </div>
          <div className="ms-5 mt-1">
            <div className="btn btn-flex btn-active-light-dark btn-sm btn-icon" data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-attach="parent" data-kt-menu-placement={`bottom-${selectedLang == 'en' ? 'end' : 'start'}`}>
              <UserSymbol picture={currentUser?.picture}/>
            </div>
            <UserMenuDropdown isFromAdminPage={true}/>
          </div>
        </div>
      </div>
      <div className="bg-body p-5 rounded mt-5 w-100">
        <Outlet />
      </div>
    </div>
  )
}

export {AdminLayout}
